module.exports = __webpack_public_path__ + "public/media/bg_profile.75da279c.svg";